import Schema, { optional, array } from 'AppReact/schema';

const label = { values: array('string'), keys: array('string'), component: optional('function') };

export default {
  selectedDates: Schema('string', 'array', { defaultValue: [] }),
  label: Schema(label, 'object', { defaultValue: { values: [], keys: [], component: null } }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  annually: Schema('boolean', 'primitive', { defaultValue: false }),
  dates: Schema('integer', 'array', { defaultValue: Array.from({ length: 31 }, (_, index) => index + 1) }),
  selectedMonthIndex: Schema('integer', 'primitive', { defaultValue: 1 })
}